// **************************
// PRE REQUIREMENTS
// **************************

export const getPreRequirementsList = (language) => {
    switch (language) {
        case 'pt':
            return PRE_REQUIREMENTS_LIST;
        break;
        case 'en':
            return EN_PRE_REQUIREMENTS_LIST;
        break;
        case 'es':
            return ES_PRE_REQUIREMENTS_LIST;
        break;
        case 'fr':
            return FR_PRE_REQUIREMENTS_LIST;
        break;
        default:
            break;
    }
}

export const getTranslatedPreRequirementsOption = (value, language) => {
    switch (language) {
        case 'pt':
            for (let i = 0; i < PRE_REQUIREMENTS_LIST.length; i++) {
                if(PRE_REQUIREMENTS_LIST[i].code === value) {
                    return { code: value, name: PRE_REQUIREMENTS_LIST[i].name };
                }
            }
        break;
        case 'en':
            for (let j = 0; j < EN_PRE_REQUIREMENTS_LIST.length; j++) {
                if(EN_PRE_REQUIREMENTS_LIST[j].code === value) {
                    return { code: value, name: EN_PRE_REQUIREMENTS_LIST[j].name };
                }
            }
        break;
        case 'es':
            for (let j = 0; j < ES_PRE_REQUIREMENTS_LIST.length; j++) {
                if(ES_PRE_REQUIREMENTS_LIST[j].code === value) {
                    return { code: value, name: ES_PRE_REQUIREMENTS_LIST[j].name };
                }
            }
        break;
        case 'fr':
            for (let j = 0; j < FR_PRE_REQUIREMENTS_LIST.length; j++) {
                if(FR_PRE_REQUIREMENTS_LIST[j].code === value) {
                    return { code: value, name: FR_PRE_REQUIREMENTS_LIST[j].name };
                }
            }
        break;
        default:
            break;
    }
}

export const PRE_REQUIREMENTS_LIST = [
    { code: "9 anos", name: "9 anos" },
    { code: "10 anos", name: "10 anos" },
    { code: "11 anos", name: "11 anos" },
    { code: "12 anos", name: "12 anos" }
];

export const EN_PRE_REQUIREMENTS_LIST = [
    { code: "9 anos", name: "9 years" },
    { code: "10 anos", name: "10 years" },
    { code: "11 anos", name: "11 years" },
    { code: "12 anos", name: "12 years" }
];

export const ES_PRE_REQUIREMENTS_LIST = [
    { code: "9 anos", name: "9 años" },
    { code: "10 anos", name: "10 años" },
    { code: "11 anos", name: "11 años" },
    { code: "12 anos", name: "12 años" }
];

export const FR_PRE_REQUIREMENTS_LIST = [
    { code: "9 anos", name: "9 ans" },
    { code: "10 anos", name: "10 ans" },
    { code: "11 anos", name: "11 ans" },
    { code: "12 anos", name: "12 ans" }
];


// **************************
// TRANING DURATION
// **************************

export const getTrainingDurationList = (language) => {
    switch (language) {
        case 'pt':
            return TRAINING_DURATION_LIST
        break;
        case 'en':
            return EN_TRAINING_DURATION_LIST;
        break;
        case 'es':
            return ES_TRAINING_DURATION_LIST;
        break;
        case 'fr':
            return FR_TRAINING_DURATION_LIST;
        break;
        default:
            break;
    }
}

export const getTranslatedTrainingDurationOption = (value, language) => {
    switch (language) {
        case 'pt':
            for (let i = 0; i < TRAINING_DURATION_LIST.length; i++) {
                if(TRAINING_DURATION_LIST[i].code === value) {
                    return { code: value, name: TRAINING_DURATION_LIST[i].name };
                }
            }
        break;
        case 'en':
            for (let j = 0; j < EN_TRAINING_DURATION_LIST.length; j++) {
                if(EN_TRAINING_DURATION_LIST[j].code === value) {
                    return { code: value, name: EN_TRAINING_DURATION_LIST[j].name };
                }
            }
        break;
        case 'es':
            for (let j = 0; j < ES_TRAINING_DURATION_LIST.length; j++) {
                if(ES_TRAINING_DURATION_LIST[j].code === value) {
                    return { code: value, name: ES_TRAINING_DURATION_LIST[j].name };
                }
            }
        break;
        case 'fr':
            for (let j = 0; j < FR_TRAINING_DURATION_LIST.length; j++) {
                if(FR_TRAINING_DURATION_LIST[j].code === value) {
                    return { code: value, name: FR_TRAINING_DURATION_LIST[j].name };
                }
            }
        break;
        default:
            break;
    }
}

export const TRAINING_DURATION_LIST = [
    { code: "1 ano", name: "1 ano" },
    { code: "2 anos", name: "2 anos" },
    { code: "3 anos", name: "3 anos" },
    { code: "4 anos", name: "4 anos" }
];

export const EN_TRAINING_DURATION_LIST = [
    { code: "1 ano", name: "1 year" },
    { code: "2 anos", name: "2 years" },
    { code: "3 anos", name: "3 years" },
    { code: "4 anos", name: "4 years" }
];

export const ES_TRAINING_DURATION_LIST = [
    { code: "1 ano", name: "1 año" },
    { code: "2 anos", name: "2 años" },
    { code: "3 anos", name: "3 años" },
    { code: "4 anos", name: "4 años" }
];

export const FR_TRAINING_DURATION_LIST = [
    { code: "1 ano", name: "1 an" },
    { code: "2 anos", name: "2 ans" },
    { code: "3 anos", name: "3 ans" },
    { code: "4 anos", name: "4 ans" }
];

// **************************
//  QUALIFICATION TYPE
// **************************

export const getQualificationTypeList = (language) => {
    switch (language) {
        case 'pt':
            return QUALIFICATION_TYPE_LIST
        break;
        case 'en':
            return EN_QUALIFICATION_TYPE_LIST;
        break;
        case 'es':
            return ES_QUALIFICATION_TYPE_LIST;
        break;
        case 'fr':
            return FR_QUALIFICATION_TYPE_LIST;
        break;
        default:
            break;
    }
}

export const getTranslatedQualificationTypeOption = (value, language) => {
    switch (language) {
        case 'pt':
            for (let i = 0; i < QUALIFICATION_TYPE_LIST.length; i++) {
                if(QUALIFICATION_TYPE_LIST[i].code === value) {
                    return { code: value, name: QUALIFICATION_TYPE_LIST[i].name };
                }
            }
        break;
        case 'en':
            for (let j = 0; j < EN_QUALIFICATION_TYPE_LIST.length; j++) {
                if(EN_QUALIFICATION_TYPE_LIST[j].code === value) {
                    return { code: value, name: EN_QUALIFICATION_TYPE_LIST[j].name };
                }
            }
        break;
        case 'es':
            for (let j = 0; j < ES_QUALIFICATION_TYPE_LIST.length; j++) {
                if(ES_QUALIFICATION_TYPE_LIST[j].code === value) {
                    return { code: value, name: ES_QUALIFICATION_TYPE_LIST[j].name };
                }
            }
        break;
        case 'fr':
            for (let j = 0; j < FR_QUALIFICATION_TYPE_LIST.length; j++) {
                if(FR_QUALIFICATION_TYPE_LIST[j].code === value) {
                    return { code: value, name: FR_QUALIFICATION_TYPE_LIST[j].name };
                }
            }
        break;
        default:
            break;
    }
}


export const QUALIFICATION_PT_OPTION = { code: "Habilitação obtida em Portugal", name: "Habilitação obtida em Portugal" };
export const QUALIFICATION_EU_OPTION = { code: "Habilitação legal obtida num estado membro da União Europeia/EFTA", name: "Habilitação legal obtida num estado membro da União Europeia/EFTA" };
export const QUALIFICATION_NON_EU_OPTION = { code: "Habilitação legal obtida num estado não membro da União Europeia/EFTA", name: "Habilitação legal obtida num estado não membro da União Europeia/EFTA" };

export const EN_QUALIFICATION_PT_OPTION = { code: "Habilitação obtida em Portugal", name: "Qualification obtained in Portugal" };
export const EN_QUALIFICATION_EU_OPTION = { code: "Habilitação legal obtida num estado membro da União Europeia/EFTA", name: "Legal qualification obtained in a member state of the European Union/EFTA" };
export const EN_QUALIFICATION_NON_EU_OPTION = { code: "Habilitação legal obtida num estado não membro da União Europeia/EFTA", name: "Legal qualification obtained in a non-member state of the European Union/EFTA" };

export const ES_QUALIFICATION_PT_OPTION = { code: "Habilitação obtida em Portugal", name: "Calificación obtenida en Portugal" };
export const ES_QUALIFICATION_EU_OPTION = { code: "Habilitação legal obtida num estado membro da União Europeia/EFTA", name: "Calificación jurídica obtenida en un Estado miembro de la Unión Europea/AELC" };
export const ES_QUALIFICATION_NON_EU_OPTION = { code: "Habilitação legal obtida num estado não membro da União Europeia/EFTA", name: "Calificación legal obtenida en un Estado no miembro de la Unión Europea/AELC" };

export const FR_QUALIFICATION_PT_OPTION = { code: "Habilitação obtida em Portugal", name: "Qualification obtenue au Portugal" };
export const FR_QUALIFICATION_EU_OPTION = { code: "Habilitação legal obtida num estado membro da União Europeia/EFTA", name: "Qualification légale obtenue dans un Etat membre de l'Union Européenne/AELE" };
export const FR_QUALIFICATION_NON_EU_OPTION = { code: "Habilitação legal obtida num estado não membro da União Europeia/EFTA", name: "Qualification légale obtenue dans un État non membre de l'Union Européenne/AELE" };

export const QUALIFICATION_TYPE_LIST = [
    QUALIFICATION_PT_OPTION,
    QUALIFICATION_EU_OPTION,
    QUALIFICATION_NON_EU_OPTION
];

export const EN_QUALIFICATION_TYPE_LIST = [
    EN_QUALIFICATION_PT_OPTION,
    EN_QUALIFICATION_EU_OPTION,
    EN_QUALIFICATION_NON_EU_OPTION
];

export const ES_QUALIFICATION_TYPE_LIST = [
    ES_QUALIFICATION_PT_OPTION,
    ES_QUALIFICATION_EU_OPTION,
    ES_QUALIFICATION_NON_EU_OPTION
];

export const FR_QUALIFICATION_TYPE_LIST = [
    FR_QUALIFICATION_PT_OPTION,
    FR_QUALIFICATION_EU_OPTION,
    FR_QUALIFICATION_NON_EU_OPTION
];

// **************************
//  TRAINING PATH
// **************************

export const getTrainingPathList = (language) => {
    switch (language) {
        case 'pt':
            return TRAINING_PATH_LIST
        break;
        case 'en':
            return EN_TRAINING_PATH_LIST;
        break;
        case 'es':
            return ES_TRAINING_PATH_LIST;
        break;
        case 'fr':
            return FR_TRAINING_PATH_LIST;
        break;
        default:
            break;
    }
}

export const getTranslatedTrainingPathOption = (value, language) => {
    switch (language) {
        case 'pt':
            for (let i = 0; i < TRAINING_PATH_LIST.length; i++) {
                if(TRAINING_PATH_LIST[i].code === value) {
                    return { code: value, name: TRAINING_PATH_LIST[i].name };
                }
            }
        break;
        case 'en':
            for (let j = 0; j < EN_TRAINING_PATH_LIST.length; j++) {
                if(EN_TRAINING_PATH_LIST[j].code === value) {
                    return { code: value, name: EN_TRAINING_PATH_LIST[j].name };
                }
            }
        break;
        case 'es':
            for (let j = 0; j < ES_TRAINING_PATH_LIST.length; j++) {
                if(ES_TRAINING_PATH_LIST[j].code === value) {
                    return { code: value, name: ES_TRAINING_PATH_LIST[j].name };
                }
            }
        break;
        case 'fr':
            for (let j = 0; j < FR_TRAINING_PATH_LIST.length; j++) {
                if(FR_TRAINING_PATH_LIST[j].code === value) {
                    return { code: value, name: FR_TRAINING_PATH_LIST[j].name };
                }
            }
        break;
        default:
            break;
    }
}

export const TRAINING_PATH_DEGREE_OPTION = { name: "Formação inicial com atribuição ou equivalência do grau de Licenciado em Fisioterapia", code: "Formação inicial com atribuição ou equivalência do grau de Licenciado em Fisioterapia" };
export const TRAINING_PATH_BACHELOR_DEGREE_OPTION = { name: "Formação inicial com atribuição ou equivalência do grau de Bacharel em Fisioterapia, mas posteriormente adquiriu o grau de licenciado em Fisioterapia (escolha esta opção apenas no caso de ter obtido o grau de Licenciado em Fisioterapia, no modelo Bietápico, ou a respetiva equivalência)", code: "Formação inicial com atribuição ou equivalência do grau de Bacharel em Fisioterapia, mas posteriormente adquiriu o grau de licenciado em Fisioterapia (escolha esta opção apenas no caso de ter obtido o grau de Licenciado em Fisioterapia, no modelo Bietápico, ou a respetiva equivalência)" };
export const TRAINING_PATH_BACHELOR_OPTION = { name: "Formação inicial com atribuição ou equivalência do grau de Bacharel em Fisioterapia (escolha esta opção no caso de ter apenas o grau de Bacharel em Fisioterapia, quer através de equivalência do seu diploma anterior, quer por ter obtido este grau diretamente)", code: "Formação inicial com atribuição ou equivalência do grau de Bacharel em Fisioterapia (escolha esta opção no caso de ter apenas o grau de Bacharel em Fisioterapia, quer através de equivalência do seu diploma anterior, quer por ter obtido este grau diretamente)" };
export const TRAINING_PATH_OTHER_OPTION = { name: "Formação em fisioterapia sem atribuição ou equivalência de grau académico (escolha esta opção apenas no caso de nunca ter obtido equivalência académica da sua formação inicial)", code: "Formação em fisioterapia sem atribuição ou equivalência de grau académico (escolha esta opção apenas no caso de nunca ter obtido equivalência académica da sua formação inicial)" };

export const EN_TRAINING_PATH_DEGREE_OPTION = { code: "Formação inicial com atribuição ou equivalência do grau de Licenciado em Fisioterapia", name: "Initial education with attribution or equivalence of the Licentiate's Degree in Physiotherapy" };
export const EN_TRAINING_PATH_BACHELOR_DEGREE_OPTION = { code: "Formação inicial com atribuição ou equivalência do grau de Bacharel em Fisioterapia, mas posteriormente adquiriu o grau de licenciado em Fisioterapia (escolha esta opção apenas no caso de ter obtido o grau de Licenciado em Fisioterapia, no modelo Bietápico, ou a respetiva equivalência)", name: "Initial education with the attribution or equivalence of the Bachelor's Degree in Physiotherapy, but later obtained the Licentiate's Degree in Physiotherapy (choose this option only in the case of having obtained the Bachelor's Degree in Physiotherapy, in the Two-stage model, or the respective equivalence)" };
export const EN_TRAINING_PATH_BACHELOR_OPTION = { code: "Formação inicial com atribuição ou equivalência do grau de Bacharel em Fisioterapia (escolha esta opção no caso de ter apenas o grau de Bacharel em Fisioterapia, quer através de equivalência do seu diploma anterior, quer por ter obtido este grau diretamente)", name: "Initial education with attribution or equivalence of the Bachelor's Degree in Physiotherapy (choose this option if you only have the Bachelor's Degree in Physiotherapy, either through equivalence of your previous diploma,or by having obtained this degree directly)" };
export const EN_TRAINING_PATH_OTHER_OPTION = { code: "Formação em fisioterapia sem atribuição ou equivalência de grau académico (escolha esta opção apenas no caso de nunca ter obtido equivalência académica da sua formação inicial)", name: "Education in physiotherapy without attribution or equivalence of academic degree (choose this option only if you have never obtained academic equivalence of your initial education)" };

export const ES_TRAINING_PATH_DEGREE_OPTION = { name: "Formación inicial con atribución o equivalencia del grado de Licenciatura en Fisioterapia", code: "Formação inicial com atribuição ou equivalência do grau de Licenciado em Fisioterapia" };
export const ES_TRAINING_PATH_BACHELOR_DEGREE_OPTION = { name: "Formación inicial con atribución o equivalencia del grado de Bachiller en Fisioterapia, pero que posteriormente adquirió el grado de Licenciatura en Fisioterapia (elija esta opción sólo en el caso de que haya obtenido el grado de Licenciatura en Fisioterapia, en el modelo Bietápico, o la respectiva equivalencia)", code: "Formação inicial com atribuição ou equivalência do grau de Bacharel em Fisioterapia, mas posteriormente adquiriu o grau de licenciado em Fisioterapia (escolha esta opção apenas no caso de ter obtido o grau de Licenciado em Fisioterapia, no modelo Bietápico, ou a respetiva equivalência)" };
export const ES_TRAINING_PATH_BACHELOR_OPTION = { name: "Formación inicial con atribución o equivalencia del grado de Bachiller en Fisioterapia (elija esta opción en caso de que sólo tenga el grado de Bachiller en Fisioterapia, tanto por equivalencia de su título anterior como por haber obtenido este grado directamente)", code: "Formação inicial com atribuição ou equivalência do grau de Bacharel em Fisioterapia (escolha esta opção no caso de ter apenas o grau de Bacharel em Fisioterapia, quer através de equivalência do seu diploma anterior, quer por ter obtido este grau diretamente)" };
export const ES_TRAINING_PATH_OTHER_OPTION = { name: "Formación en Fisioterapia sin atribución o equivalencia de grado académico (elegir esta opción sólo en caso de no haber obtenido nunca la equivalencia académica de su formación inicial)", code: "Formação em fisioterapia sem atribuição ou equivalência de grau académico (escolha esta opção apenas no caso de nunca ter obtido equivalência académica da sua formação inicial)" };

export const FR_TRAINING_PATH_DEGREE_OPTION = { name: "Formation initiale avec attribution ou équivalence de la Licence en Physiothérapie", code: "Formação inicial com atribuição ou equivalência do grau de Licenciado em Fisioterapia" };
export const FR_TRAINING_PATH_BACHELOR_DEGREE_OPTION = { name: "Formation initiale avec attribution ou équivalence du Baccalauréat en Physiothérapie mais ultérieurement a acquis la Licence en Physiothérapie (choisissez cette option seulement si vous avez obtenu la Licence en Physiothérapie dans le modèle en deux étapes ou l'équivalence respective)", code: "Formação inicial com atribuição ou equivalência do grau de Bacharel em Fisioterapia, mas posteriormente adquiriu o grau de licenciado em Fisioterapia (escolha esta opção apenas no caso de ter obtido o grau de Licenciado em Fisioterapia, no modelo Bietápico, ou a respetiva equivalência)" };
export const FR_TRAINING_PATH_BACHELOR_OPTION = { name: "Formation initiale avec attribution ou équivalence du Baccalauréat en Physiothérapie (choisissez cette option si vous n'avez que le Baccalauréat en Physiothérapie, soit par équivalence de votre diplôme antérieur, soit en ayant obtenu ce diplôme directement)", code: "Formação inicial com atribuição ou equivalência do grau de Bacharel em Fisioterapia (escolha esta opção no caso de ter apenas o grau de Bacharel em Fisioterapia, quer através de equivalência do seu diploma anterior, quer por ter obtido este grau diretamente)" };
export const FR_TRAINING_PATH_OTHER_OPTION = { name: "Formation en Physiothérapie sans attribution ou équivalence de grade académique (choisissez cette option seulement si vous n'avez jamais obtenu d'équivalence académique de votre formation initiale)", code: "Formação em fisioterapia sem atribuição ou equivalência de grau académico (escolha esta opção apenas no caso de nunca ter obtido equivalência académica da sua formação inicial)" };

export const TRAINING_PATH_LIST = [
    TRAINING_PATH_DEGREE_OPTION,
    TRAINING_PATH_BACHELOR_DEGREE_OPTION,
    TRAINING_PATH_BACHELOR_OPTION,
    TRAINING_PATH_OTHER_OPTION
];

export const EN_TRAINING_PATH_LIST = [
    EN_TRAINING_PATH_DEGREE_OPTION,
    EN_TRAINING_PATH_BACHELOR_DEGREE_OPTION,
    EN_TRAINING_PATH_BACHELOR_OPTION,
    EN_TRAINING_PATH_OTHER_OPTION
];

export const ES_TRAINING_PATH_LIST = [
    ES_TRAINING_PATH_DEGREE_OPTION,
    ES_TRAINING_PATH_BACHELOR_DEGREE_OPTION,
    ES_TRAINING_PATH_BACHELOR_OPTION,
    ES_TRAINING_PATH_OTHER_OPTION
];

export const FR_TRAINING_PATH_LIST = [
    FR_TRAINING_PATH_DEGREE_OPTION,
    FR_TRAINING_PATH_BACHELOR_DEGREE_OPTION,
    FR_TRAINING_PATH_BACHELOR_OPTION,
    FR_TRAINING_PATH_BACHELOR_OPTION
];

// **************************
// OTHER TRAINING
// **************************

export const getOtherTrainingList = (language) => {
    switch (language) {
        case 'pt':
            return OTHER_TRAINING_LIST
        break;
        case 'en':
            return EN_OTHER_TRAINING_LIST;
        break;
        case 'es':
            return ES_OTHER_TRAINING_LIST;
        break;
        case 'fr':
            return FR_OTHER_TRAINING_LIST;
        break;
        default:
            break;
    }
}

export const getTranslatedOtherTrainingOption = (value, language) => {
    switch (language) {
        case 'pt':
            for (let i = 0; i < OTHER_TRAINING_LIST.length; i++) {
                if(OTHER_TRAINING_LIST[i].code === value) {
                    return { code: value, name: OTHER_TRAINING_LIST[i].name };
                }
            }
        break;
        case 'en':
            for (let j = 0; j < EN_OTHER_TRAINING_LIST.length; j++) {
                if(EN_OTHER_TRAINING_LIST[j].code === value) {
                    return { code: value, name: EN_OTHER_TRAINING_LIST[j].name };
                }
            }
        break;
        case 'es':
            for (let j = 0; j < ES_OTHER_TRAINING_LIST.length; j++) {
                if(ES_OTHER_TRAINING_LIST[j].code === value) {
                    return { code: value, name: ES_OTHER_TRAINING_LIST[j].name };
                }
            }
        break;
        case 'fr':
            for (let j = 0; j < FR_OTHER_TRAINING_LIST.length; j++) {
                if(FR_OTHER_TRAINING_LIST[j].code === value) {
                    return { code: value, name: FR_OTHER_TRAINING_LIST[j].name };
                }
            }
        break;
        default:
            break;
    }
}

export const OTHER_TRAINING_LIST = [
    { code: "Nenhuma", name: "Nenhuma" },
    { code: "Até 28 horas (inclusive)", name: "Até 28 horas (inclusive)" },
    { code: "De 29 a 56 horas (inclusivé)", name: "De 29 a 56 horas (inclusivé)" },
    { code: "De 57 a 84 horas (inclusivé)", name: "De 57 a 84 horas (inclusivé)" },
    { code: "De 85 a 112 horas (inclusivé)", name: "De 85 a 112 horas (inclusivé)" },
    { code: "Mais de 112 horas", name: "Mais de 112 horas" }
];

export const EN_OTHER_TRAINING_LIST = [
    { code: "Nenhuma", name: "None" },
    { code: "Até 28 horas (inclusive)", name: "Up to 28 hours (inclusive)" },
    { code: "De 29 a 56 horas (inclusivé)", name: "From 29 to 56 hours (inclusive)" },
    { code: "De 57 a 84 horas (inclusivé)", name: "From 57 to 84 hours (inclusive)" },
    { code: "De 85 a 112 horas (inclusivé)", name: "From 85 to 112 hours (inclusive)" },
    { code: "Mais de 112 horas", name: "More than 112 hours" }
];

export const ES_OTHER_TRAINING_LIST = [
    { code: "Nenhuma", name: "Ninguna" },
    { code: "Até 28 horas (inclusive)", name: "Hasta 28 horas (inclusive)" },
    { code: "De 29 a 56 horas (inclusivé)", name: "De 29 a 56 horas (inclusive)" },
    { code: "De 57 a 84 horas (inclusivé)", name: "De 57 a 84 horas (inclusive)" },
    { code: "De 85 a 112 horas (inclusivé)", name: "De 85 a 112 horas (inclusive)" },
    { code: "Mais de 112 horas", name: "Más de 112 horas" }
];

export const FR_OTHER_TRAINING_LIST = [
    { code: "Nenhuma", name: "Aucune" },
    { code: "Até 28 horas (inclusive)", name: "Jusqu'à 28 heures (inclus)" },
    { code: "De 29 a 56 horas (inclusivé)", name: "De 29 à 56 horas (inclus)" },
    { code: "De 57 a 84 horas (inclusivé)", name: "De 57 à 84 horas (inclus)" },
    { code: "De 85 a 112 horas (inclusivé)", name: "De 85 à 112 horas (inclus)" },
    { code: "Mais de 112 horas", name: "Plus de 112 heures" }
];

// **************************
// PHYSIO POST GRAD
// **************************

export const getPhysioPostGradList = (language) => {
    switch (language) {
        case 'pt':
            return PHYSIO_POST_GRAD_LIST
        break;
        case 'en':
            return EN_PHYSIO_POST_GRAD_LIST;
        break;
        case 'es':
            return ES_PHYSIO_POST_GRAD_LIST;
        break;
        case 'fr':
            return FR_PHYSIO_POST_GRAD_LIST;
        break;
        default:
            break;
    }
}

export const getTranslatedPhysioPostGradOption = (value, language) => {
    switch (language) {
        case 'pt':
            for (let i = 0; i < PHYSIO_POST_GRAD_LIST.length; i++) {
                if(PHYSIO_POST_GRAD_LIST[i].code === value) {
                    return { code: value, name: PHYSIO_POST_GRAD_LIST[i].name };
                }
            }
        break;
        case 'en':
            for (let i = 0; i < EN_PHYSIO_POST_GRAD_LIST.length; i++) {
                if(EN_PHYSIO_POST_GRAD_LIST[i].code === value) {
                    return { code: value, name: EN_PHYSIO_POST_GRAD_LIST[i].name };
                }
            }
        break;
        case 'es':
            for (let i = 0; i < ES_PHYSIO_POST_GRAD_LIST.length; i++) {
                if(ES_PHYSIO_POST_GRAD_LIST[i].code === value) {
                    return { code: value, name: ES_PHYSIO_POST_GRAD_LIST[i].name };
                }
            }
        break;
        case 'fr':
            for (let i = 0; i < FR_PHYSIO_POST_GRAD_LIST.length; i++) {
                if(FR_PHYSIO_POST_GRAD_LIST[i].code === value) {
                    return { code: value, name: FR_PHYSIO_POST_GRAD_LIST[i].name };
                }
            }
        break;
        default:
            break;
    }
}

export const PHYSIO_POST_GRAD_LIST = [
    { code: "Pós-Graduação em Fisioterapia", name: "Pós-Graduação em Fisioterapia" },
    { code: "Mestrado em Fisioterapia", name: "Mestrado em Fisioterapia" },
    { code: "Doutoramento em Fisioterapia", name: "Doutoramento em Fisioterapia" },
    { code: "Título de Especialista em Fisioterapia Decreto Lei mº206/2009, de 31 de agosto", name: "Título de Especialista em Fisioterapia Decreto Lei mº206/2009, de 31 de agosto" }
];
export const EN_PHYSIO_POST_GRAD_LIST = [
    { code: "Pós-Graduação em Fisioterapia", name: "Post-Graduation Degree in Physiotherapy" },
    { code: "Mestrado em Fisioterapia", name: "Master's Degree in Physiotherapy" },
    { code: "Doutoramento em Fisioterapia", name: "PhD in Physiotherapy" },
    { code: "Título de Especialista em Fisioterapia Decreto Lei mº206/2009, de 31 de agosto", name: "Title of Physiotherapy Specialist Decree Law No. 206/2009 of August 31st" }
];

export const ES_PHYSIO_POST_GRAD_LIST = [
    { code: "Pós-Graduação em Fisioterapia", name: "Posgrado en Fisioterapia" },
    { code: "Mestrado em Fisioterapia", name: "Máster en Fisioterapia" },
    { code: "Doutoramento em Fisioterapia", name: "Doctorado en Fisioterapia" },
    { code: "Título de Especialista em Fisioterapia Decreto Lei mº206/2009, de 31 de agosto", name: "Título de Especialista en Fisioterapia Decreto-Ley mº206/2009 de 31 de agosto" }
];

export const FR_PHYSIO_POST_GRAD_LIST = [
    { code: "Pós-Graduação em Fisioterapia", name: "Troisième cycle en Physiothérapie" },
    { code: "Mestrado em Fisioterapia", name: "Master en Physiothérapie" },
    { code: "Doutoramento em Fisioterapia", name: "Doctorat en Physiothérapie" },
    { code: "Título de Especialista em Fisioterapia Decreto Lei mº206/2009, de 31 de agosto", name: "Titre de Spécialiste en Physiothérapie Décret-loi 206/2009 du 31 août" }
];

// **************************
// OTHER POST GRAD
// **************************

export const getOtherPostGradList = (language) => {
    switch (language) {
        case 'pt':
            return OTHER_POST_GRAD_LIST
        break;
        case 'en':
            return EN_OTHER_POST_GRAD_LIST;
        break;
        case 'es':
            return ES_OTHER_POST_GRAD_LIST;
        break;
        case 'fr':
            return FR_OTHER_POST_GRAD_LIST;
        break;
        default:
            break;
    }
}

export const getTranslatedOtherPostGradOption = (value, language) => {
    switch (language) {
        case 'pt':
            for (let i = 0; i < OTHER_POST_GRAD_LIST.length; i++) {
                if(OTHER_POST_GRAD_LIST[i].code === value) {
                    return { code: value, name: OTHER_POST_GRAD_LIST[i].name };
                }
            }
        break;
        case 'en':
            for (let i = 0; i < EN_OTHER_POST_GRAD_LIST.length; i++) {
                if(EN_OTHER_POST_GRAD_LIST[i].code === value) {
                    return { code: value, name: EN_OTHER_POST_GRAD_LIST[i].name };
                }
            }
        break;
        case 'es':
            for (let i = 0; i < ES_OTHER_POST_GRAD_LIST.length; i++) {
                if(ES_OTHER_POST_GRAD_LIST[i].code === value) {
                    return { code: value, name: ES_OTHER_POST_GRAD_LIST[i].name };
                }
            }
        break;
        case 'fr':
            for (let i = 0; i < FR_OTHER_POST_GRAD_LIST.length; i++) {
                if(FR_OTHER_POST_GRAD_LIST[i].code === value) {
                    return { code: value, name: FR_OTHER_POST_GRAD_LIST[i].name };
                }
            }
        break;
        default:
            break;
    }
}

export const OTHER_POST_GRAD_LIST = [
    { code: "Licenciatura fora de Fisioterapia", name: "Licenciatura fora de Fisioterapia" },
    { code: "Pós-Graduação fora de Fisioterapia", name: "Pós-Graduação fora de Fisioterapia" },
    { code: "Mestrado fora de Fisioterapia", name: "Mestrado fora de Fisioterapia" },
    { code: "Doutoramento fora de Fisioterapia", name: "Doutoramento fora de Fisioterapia" },
    { code: "Pós-Doutoramento", name: "Pós-Doutoramento" },
    { code: "Agregação", name: "Agregação" }
];

export const EN_OTHER_POST_GRAD_LIST = [
    { code: "Licenciatura fora de Fisioterapia", name: "Licenciate's Degree outside Physiotherapy" },
    { code: "Pós-Graduação fora de Fisioterapia", name: "Post-Graduation Degree outside Physiotherapy" },
    { code: "Mestrado fora de Fisioterapia", name: "Master's Degree outside Physiotherapy" },
    { code: "Doutoramento fora de Fisioterapia", name: "PhD outside Physiotherapy" },
    { code: "Pós-Doutoramento", name: "Post-Doctorate Degree" },
    { code: "Agregação", name: "Aggregation" }
];

export const ES_OTHER_POST_GRAD_LIST = [
    { code: "Licenciatura fora de Fisioterapia", name: "Licenciatura fuera de la Fisioterapia" },
    { code: "Pós-Graduação fora de Fisioterapia", name: "Posgrado fuera de la Fisioterapia" },
    { code: "Mestrado fora de Fisioterapia", name: "Máster fuera de la Fisioterapia" },
    { code: "Doutoramento fora de Fisioterapia", name: "Doctorado fuera de la Fisioterapia" },
    { code: "Pós-Doutoramento", name: "Posdoctorado" },
    { code: "Agregação", name: "Agregación" }
];

export const FR_OTHER_POST_GRAD_LIST = [
    { code: "Licenciatura fora de Fisioterapia", name: "Licence en dehors de la Physiothérapie" },
    { code: "Pós-Graduação fora de Fisioterapia", name: "Troisième cycle en dehors de la Physiothérapie" },
    { code: "Mestrado fora de Fisioterapia", name: "Master en dehors de la Physiothérapie" },
    { code: "Doutoramento fora de Fisioterapia", name: "Doctorat en dehors de la Physiothérapie" },
    { code: "Pós-Doutoramento", name: "Post-Doctorat" },
    { code: "Agregação", name: "Agrégation" }
];


export const PT_SCHOOL_LIST = [
    { code: "- Escola Superior de Saúde Atlântica / Escola Superior de Saúde Atlântica, da Universidade Atlântica", name: "- Escola Superior de Saúde Atlântica / Escola Superior de Saúde Atlântica, da Universidade Atlântica" },
    { code: "- Escola Superior de Saúde Dr. Lopes Dias - IP Castelo Branco", name: "- Escola Superior de Saúde Dr. Lopes Dias - IP Castelo Branco" },
    { code: "- Escola Superior de Saúde Egas Moniz", name: "- Escola Superior de Saúde Egas Moniz" },
    { code: "- Escola Superior de Saúde IP Porto / Escola Superior de Tecnologia da Saúde do Porto / Escola Técnica dos Serviços de Saúde do Porto", name: "- Escola Superior de Saúde IP Porto / Escola Superior de Tecnologia da Saúde do Porto / Escola Técnica dos Serviços de Saúde do Porto" },
    { code: "- Escola Superior de Saúde Jean Piaget - Nordeste", name: "- Escola Superior de Saúde Jean Piaget - Nordeste" },
    { code: "- Escola Superior de Saúde Jean Piaget - Vila Nova de Gaia", name: "- Escola Superior de Saúde Jean Piaget - Vila Nova de Gaia" },
    { code: "- Escola Superior de Saúde Jean Piaget - Viseu", name: "- Escola Superior de Saúde Jean Piaget - Viseu" },
    { code: "- Escola Superior de Saúde Jean Piaget - Algarve", name: "- Escola Superior de Saúde Jean Piaget - Algarve" },
    { code: "- Escola Superior de Saúde da Cruz Vermelha Portuguesa — Lisboa / Escola Superior de Saúde da Cruz Vermelha Portuguesa", name: "- Escola Superior de Saúde da Cruz Vermelha Portuguesa — Lisboa / Escola Superior de Saúde da Cruz Vermelha Portuguesa" },
    { code: "- Escola Superior de Saúde da Fundação «Fernando Pessoa» / Escola Superior de Saúde da Universidade Fernando Pessoa", name: "- Escola Superior de Saúde da Fundação «Fernando Pessoa» / Escola Superior de Saúde da Universidade Fernando Pessoa" },
    { code: "- Escola Superior de Saúde de Aveiro, da Universidade de Aveiro", name: "- Escola Superior de Saúde de Aveiro, da Universidade de Aveiro" },
    { code: "- Escola Superior de Saúde de Santa Maria", name: "- Escola Superior de Saúde de Santa Maria" },
    { code: "- Escola Superior de Saúde do Alcoitão / Escola de Reabilitação do Alcoitão", name: "- Escola Superior de Saúde do Alcoitão / Escola de Reabilitação do Alcoitão" },
    { code: "- Escola Superior de Saúde do IP Leiria", name: "- Escola Superior de Saúde do IP Leiria" },
    { code: "- Escola Superior de Saúde do IP Setúbal", name: "- Escola Superior de Saúde do IP Setúbal" },
    { code: "- Escola Superior de Saùde Jean Piaget Campus de Almada", name: "- Escola Superior de Saùde Jean Piaget Campus de Almada" },
    { code: "- Escola Superior de Saúde da Universidade do Algarve", name: "- Escola Superior de Saúde da Universidade do Algarve" },
    { code: "- Escola Superior de Tecnologia da Saúde de Coimbra / Escola Técnica dos Serviços de Saúde de Coimbra", name: "- Escola Superior de Tecnologia da Saúde de Coimbra / Escola Técnica dos Serviços de Saúde de Coimbra" },
    { code: "- Escola Superior de Tecnologia da Saúde de Lisboa / Escola Técnica dos Serviços de Saúde de Lisboa", name: "- Escola Superior de Tecnologia da Saúde de Lisboa / Escola Técnica dos Serviços de Saúde de Lisboa" },
    { code: "- IPS Norte - ESS Vale do Ave / Escola Superior de Saúde do Vale do Ave", name: "- IPS Norte - ESS Vale do Ave / Escola Superior de Saúde do Vale do Ave" },
    { code: "- IPS Norte - ESS Vale do Sousa / Escola Superior de Saúde do Vale do Sousa / Instituto Superior de Ciências da Saúde - Norte - Escola Superior de Saúde do Vale do Sousa", name: "- IPS Norte - ESS Vale do Sousa / Escola Superior de Saúde do Vale do Sousa / Instituto Superior de Ciências da Saúde - Norte - Escola Superior de Saúde do Vale do Sousa" },
    { code: "- ISAVE - Instituto Superior de Saúde / Instituto Superior de Saúde do Alto Ave", name: "- ISAVE - Instituto Superior de Saúde / Instituto Superior de Saúde do Alto Ave" },
    { code: "Outra", name: "Outra" }
];

export const OTHER_ENTITY_OPTION = { code: "- Outra entidade", name: "- Outra entidade" };

export const EQUIV_SCHOOL_LIST = [
    { code: "- Escola Superior de Saúde IP Porto / Escola Superior de Tecnologia da Saúde do Porto / Escola Técnica dos Serviços de Saúde do Porto", name: "- Escola Superior de Saúde IP Porto / Escola Superior de Tecnologia da Saúde do Porto / Escola Técnica dos Serviços de Saúde do Porto" },
    { code: "- Escola Superior de Tecnologia da Saúde de Coimbra / Escola Técnica dos Serviços de Saúde de Coimbra", name: "- Escola Superior de Tecnologia da Saúde de Coimbra / Escola Técnica dos Serviços de Saúde de Coimbra" },
    { code: "- Escola Superior de Tecnologia da Saúde de Lisboa / Escola Técnica dos Serviços de Saúde de Lisboa", name: "- Escola Superior de Tecnologia da Saúde de Lisboa / Escola Técnica dos Serviços de Saúde de Lisboa" },
    { code: "- Escola Superior de Saúde de Aveiro, da Universidade de Aveiro", name: "- Escola Superior de Saúde de Aveiro, da Universidade de Aveiro" },
    { code: "- Escola Superior de Saúde do IP Leiria", name: "- Escola Superior de Saúde do IP Leiria" },
    { code: "- Escola Superior de Saúde do IP Setúbal", name: "- Escola Superior de Saúde do IP Setúbal" },
    { code: "- Escola Superior de Saúde Dr. Lopes Dias - IP Castelo Branco", name: "- Escola Superior de Saúde Dr. Lopes Dias - IP Castelo Branco" },
    { code: "- DRHS (Departamento de Recursos Humanos da Saúde)", name: "- DRHS (Departamento de Recursos Humanos da Saúde)" },
    { code: "- Outra entidade", name: "- Outra entidade" }
]

// **************************
// DEGREE LIST
// **************************

export const getDegreeLevelList = (language) => {
    switch (language) {
        case 'pt':
            return EU_NON_EU_DEGREE_LIST
        break;
        case 'en':
            return EN_EU_NON_EU_DEGREE_LIST;
        break;
        case 'es':
            return ES_EU_NON_EU_DEGREE_LIST;
        break;
        case 'fr':
            return FR_EU_NON_EU_DEGREE_LIST;
        break;
        default:
            break;
    }
}

export const getTranslatedDegreeLevelOption = (value, language) => {
    switch (language) {
        case 'pt':
            for (let i = 0; i < EU_NON_EU_DEGREE_LIST.length; i++) {
                if(EU_NON_EU_DEGREE_LIST[i].code === value) {
                    return { code: value, name: EU_NON_EU_DEGREE_LIST[i].name };
                }
            }
        break;
        case 'en':
            for (let j = 0; j < EN_EU_NON_EU_DEGREE_LIST.length; j++) {
                if(EN_EU_NON_EU_DEGREE_LIST[j].code === value) {
                    return { code: value, name: EN_EU_NON_EU_DEGREE_LIST[j].name };
                }
            }
        break;
        case 'es':
            for (let j = 0; j < ES_EU_NON_EU_DEGREE_LIST.length; j++) {
                if(ES_EU_NON_EU_DEGREE_LIST[j].code === value) {
                    return { code: value, name: ES_EU_NON_EU_DEGREE_LIST[j].name };
                }
            }
        break;
        case 'fr':
            for (let j = 0; j < FR_EU_NON_EU_DEGREE_LIST.length; j++) {
                if(FR_EU_NON_EU_DEGREE_LIST[j].code === value) {
                    return { code: value, name: FR_EU_NON_EU_DEGREE_LIST[j].name };
                }
            }
        break;
        default:
            break;
    }
}

export const EU_NON_EU_DEGREE_LIST = [
    { code: "Diploma Profissional (EQF 4 / ISCED 11- Nivel 4 )", name: "Diploma Profissional (EQF 4 / ISCED 11- Nivel 4 )" },
    { code: "Diploma Profissional (EQF 5 / ISCED 11- Nivel 5 )", name: "Diploma Profissional (EQF 5 / ISCED 11- Nivel 5 )" },
    { code: "Bacharelato ou Licenciatura (1º ciclo de Bolonha) EQF6 / ISCED 11 - Nível 6", name: "Bacharelato ou Licenciatura (1º ciclo de Bolonha) EQF6 / ISCED 11 - Nível 6" },
    { code: "Mestrado Integrado (2º ciclo de Bolonha) EQF7 / ISCED11 - Nível 7", name: "Mestrado Integrado (2º ciclo de Bolonha) EQF7 / ISCED11 - Nível 7" },
    { code: "Doutor ou equivalente  EQF 8 /ISCED 11- Nível 8", name: "Doutor ou equivalente  EQF 8 /ISCED 11- Nível 8" }
];

export const EN_EU_NON_EU_DEGREE_LIST = [
    { code: "Diploma Profissional (EQF 4 / ISCED 11- Nivel 4 )", name: "Professional Diploma (EQF 4 / ISCED 11- Level 4)" },
    { code: "Diploma Profissional (EQF 5 / ISCED 11- Nivel 5 )", name: "Professional Diploma (EQF 5 / ISCED 11- Level 5)" },
    { code: "Bacharelato ou Licenciatura (1º ciclo de Bolonha) EQF6 / ISCED 11 - Nível 6", name: "Bachelor's or Licentiate's Degree (1st Bologna cycle) (EQF6 / ISCED 11 - Level 6)" },
    { code: "Mestrado Integrado (2º ciclo de Bolonha) EQF7 / ISCED11 - Nível 7", name: "Integrated Master's Degree (2nd Bologna cycle) (EQF7 / ISCED11 - Level 7)" },
    { code: "Doutor ou equivalente  EQF 8 /ISCED 11- Nível 8", name: "PhD or equivalent (EQF 8 /ISCED 11- Level 8)" }
];

export const ES_EU_NON_EU_DEGREE_LIST = [
    { code: "Diploma Profissional (EQF 4 / ISCED 11- Nivel 4 )", name: "Diploma profesional (MEC 4 / CINE 11- Nivel 4)" },
    { code: "Diploma Profissional (EQF 5 / ISCED 11- Nivel 5 )", name: "Diploma profesional (MEC 5 / CINE 11- Nivel 5)" },
    { code: "Bacharelato ou Licenciatura (1º ciclo de Bolonha) EQF6 / ISCED 11 - Nível 6", name: "Bachillerato o Licenciatura (1er ciclo de Bolonia) MEC6 / CINE 11 - Nivel 6" },
    { code: "Mestrado Integrado (2º ciclo de Bolonha) EQF7 / ISCED11 - Nível 7", name: "Máster Integrado (2º ciclo de Bolonia) MEC7 / CINE11 - Nivel 7" },
    { code: "Doutor ou equivalente  EQF 8 /ISCED 11- Nível 8", name: "Doctorado o equivalente MEC 8 / CINE 11- Nivel 8" }
];

export const FR_EU_NON_EU_DEGREE_LIST = [
    { code: "Diploma Profissional (EQF 4 / ISCED 11- Nivel 4 )", name: "Diplôme professionnel (CEC 4 / CITE 11- Niveau 4)" },
    { code: "Diploma Profissional (EQF 5 / ISCED 11- Nivel 5 )", name: "Diplôme professionnel (CEC 5 / CITE 11- Niveau 5)" },
    { code: "Bacharelato ou Licenciatura (1º ciclo de Bolonha) EQF6 / ISCED 11 - Nível 6", name: "Baccalauréat ou Licence (1er cycle de Bologne) CEC 6 / CITE 11 - Niveau 6" },
    { code: "Mestrado Integrado (2º ciclo de Bolonha) EQF7 / ISCED11 - Nível 7", name: "Master Intégré (2ème cycle de Bologne) CEC 7 / CITE 11 - Niveau 7" },
    { code: "Doutor ou equivalente  EQF 8 /ISCED 11- Nível 8", name: "Doctorat ou équivalent (CEC 8 / CITE 11- Niveau 8)" }
];


// **************************
// EU PRE REQUIREMENTS
// **************************

export const getEuPreRequirementsList = (language) => {
    switch (language) {
        case 'pt':
            return EU_NON_EU_PRE_REQUIREMENTS_LIST
        break;
        case 'en':
            return EN_EU_NON_EU_PRE_REQUIREMENTS_LIST;
        break;
        case 'es':
            return ES_EU_NON_EU_PRE_REQUIREMENTS_LIST;
        break;
        case 'fr':
            return FR_EU_NON_EU_PRE_REQUIREMENTS_LIST;
        break;
        default:
            break;
    }
}

export const getTranslatedEuPreRequirementsOption = (value, language) => {
    switch (language) {
        case 'pt':
            for (let i = 0; i < EU_NON_EU_PRE_REQUIREMENTS_LIST.length; i++) {
                if(EU_NON_EU_PRE_REQUIREMENTS_LIST[i].code === value) {
                    return { code: value, name: EU_NON_EU_PRE_REQUIREMENTS_LIST[i].name };
                }
            }
        break;
        case 'en':
            for (let j = 0; j < EN_EU_NON_EU_PRE_REQUIREMENTS_LIST.length; j++) {
                if(EN_EU_NON_EU_PRE_REQUIREMENTS_LIST[j].code === value) {
                    return { code: value, name: EN_EU_NON_EU_PRE_REQUIREMENTS_LIST[j].name };
                }
            }
        break;
        case 'es':
            for (let j = 0; j < ES_EU_NON_EU_PRE_REQUIREMENTS_LIST.length; j++) {
                if(ES_EU_NON_EU_PRE_REQUIREMENTS_LIST[j].code === value) {
                    return { code: value, name: ES_EU_NON_EU_PRE_REQUIREMENTS_LIST[j].name };
                }
            }
        break;
        case 'fr':
            for (let j = 0; j < FR_EU_NON_EU_PRE_REQUIREMENTS_LIST.length; j++) {
                if(FR_EU_NON_EU_PRE_REQUIREMENTS_LIST[j].code === value) {
                    return { code: value, name: FR_EU_NON_EU_PRE_REQUIREMENTS_LIST[j].name };
                }
            }
        break;
        default:
            break;
    }
}

export const EU_NON_EU_PRE_REQUIREMENTS_LIST = [
    { code: "9 anos", name: "9 anos" },
    { code: "10 anos", name: "10 anos" },
    { code: "11 anos", name: "11 anos" },
    { code: "12 anos", name: "12 anos" },
    { code: "13 anos", name: "13 anos" },
    { code: "14 anos", name: "14 anos" }
];

export const EN_EU_NON_EU_PRE_REQUIREMENTS_LIST = [
    { code: "9 anos", name: "9 years" },
    { code: "10 anos", name: "10 years" },
    { code: "11 anos", name: "11 years" },
    { code: "12 anos", name: "12 years" },
    { code: "13 anos", name: "13 years" },
    { code: "14 anos", name: "14 years" }
];

export const ES_EU_NON_EU_PRE_REQUIREMENTS_LIST = [
    { code: "9 anos", name: "9 años" },
    { code: "10 anos", name: "10 años" },
    { code: "11 anos", name: "11 años" },
    { code: "12 anos", name: "12 años" },
    { code: "13 anos", name: "13 años" },
    { code: "14 anos", name: "14 años" }
];

export const FR_EU_NON_EU_PRE_REQUIREMENTS_LIST = [
    { code: "9 anos", name: "9 ans" },
    { code: "10 anos", name: "10 ans" },
    { code: "11 anos", name: "11 ans" },
    { code: "12 anos", name: "12 ans" },
    { code: "13 anos", name: "13 ans" },
    { code: "14 anos", name: "14 ans" }
];

// **************************
// EU TRANING DURATION
// **************************

export const getEuTrainingDurationList = (language) => {
    switch (language) {
        case 'pt':
            return EU_NON_EU_TRAINING_DURATION_LIST
        break;
        case 'en':
            return EN_EU_NON_EU_TRAINING_DURATION_LIST;
        break;
        case 'es':
            return ES_EU_NON_EU_TRAINING_DURATION_LIST;
        break;
        case 'fr':
            return FR_EU_NON_EU_TRAINING_DURATION_LIST;
        break;
        default:
            break;
    }
}

export const getTranslatedEuTrainingDurationOption = (value, language) => {
    switch (language) {
        case 'pt':
            for (let i = 0; i < EU_NON_EU_TRAINING_DURATION_LIST.length; i++) {
                if(EU_NON_EU_TRAINING_DURATION_LIST[i].code === value) {
                    return { code: value, name: EU_NON_EU_TRAINING_DURATION_LIST[i].name };
                }
            }
        break;
        case 'en':
            for (let j = 0; j < EN_EU_NON_EU_TRAINING_DURATION_LIST.length; j++) {
                if(EN_EU_NON_EU_TRAINING_DURATION_LIST[j].code === value) {
                    return { code: value, name: EN_EU_NON_EU_TRAINING_DURATION_LIST[j].name };
                }
            }
        break;
        case 'es':
            for (let j = 0; j < ES_EU_NON_EU_TRAINING_DURATION_LIST.length; j++) {
                if(ES_EU_NON_EU_TRAINING_DURATION_LIST[j].code === value) {
                    return { code: value, name: ES_EU_NON_EU_TRAINING_DURATION_LIST[j].name };
                }
            }
        break;
        case 'fr':
            for (let j = 0; j < FR_EU_NON_EU_TRAINING_DURATION_LIST.length; j++) {
                if(FR_EU_NON_EU_TRAINING_DURATION_LIST[j].code === value) {
                    return { code: value, name: FR_EU_NON_EU_TRAINING_DURATION_LIST[j].name };
                }
            }
        break;
        default:
            break;
    }
}

export const EU_NON_EU_TRAINING_DURATION_LIST = [
    { code: "Menos de 3 anos letivos - menos de 180 ECTS", name: "Menos de 3 anos letivos - menos de 180 ECTS" },
    { code: "3 anos letivos - 180 ECTS", name: "3 anos letivos - 180 ECTS" },
    { code: "3,5 anos letivos - 210 ECTS", name: "3,5 anos letivos - 210 ECTS" },
    { code: "4 anos letivos - 240 ECTS", name: "4 anos letivos - 240 ECTS" },
    { code: "Mais de 4 anos letivos - mais de 240 ECTS", name: "Mais de 4 anos letivos - mais de 240 ECTS" }
];

export const EN_EU_NON_EU_TRAINING_DURATION_LIST = [
    { code: "Menos de 3 anos letivos - menos de 180 ECTS", name: "Less than 3 academic years - less than 180 ECTS" },
    { code: "3 anos letivos - 180 ECTS", name: "3 academic years - 180 ECTS" },
    { code: "3,5 anos letivos - 210 ECTS", name: "3 1/2 academic years - 210 ECTS" },
    { code: "4 anos letivos - 240 ECTS", name: "4 academic years - 240 ECTS" },
    { code: "Mais de 4 anos letivos - mais de 240 ECTS", name: "More than 4 academic years - more than 240 ECTS" }
];

export const ES_EU_NON_EU_TRAINING_DURATION_LIST = [
    { code: "Menos de 3 anos letivos - menos de 180 ECTS", name: "Menos de 3 años académicos - menos de 180 ECTS" },
    { code: "3 anos letivos - 180 ECTS", name: "3 años académicos - 180 ECTS" },
    { code: "3,5 anos letivos - 210 ECTS", name: "3,5 años académicos - 210 ECTS" },
    { code: "4 anos letivos - 240 ECTS", name: "4 años académicos - 240 ECTS" },
    { code: "Mais de 4 anos letivos - mais de 240 ECTS", name: "Más de 4 años académicos - más de 240 ECTS" }
];

export const FR_EU_NON_EU_TRAINING_DURATION_LIST = [
    { code: "Menos de 3 anos letivos - menos de 180 ECTS", name: "Moins de 3 années universitaires - moins de 180 ECTS" },
    { code: "3 anos letivos - 180 ECTS", name: "3 années universitaires - 180 ECTS" },
    { code: "3,5 anos letivos - 210 ECTS", name: "3,5 années universitaires - 210 ECTS" },
    { code: "4 anos letivos - 240 ECTS", name: "4 années universitaires - 240 ECTS" },
    { code: "Mais de 4 anos letivos - mais de 240 ECTS", name: "Plus de 4 années universitaires - plus de 240 ECTS" }
];

// **************************
// EU TRANING MODE
// **************************

export const getEuTrainingModeList = (language) => {
    switch (language) {
        case 'pt':
            return EU_NON_EU_TRAINING_MODE_LIST
        break;
        case 'en':
            return EN_EU_NON_EU_TRAINING_MODE_LIST;
        break;
        case 'es':
            return ES_EU_NON_EU_TRAINING_MODE_LIST;
        break;
        case 'fr':
            return FR_EU_NON_EU_TRAINING_MODE_LIST;
        break;
        default:
            break;
    }
}

export const getTranslatedEuTrainingModeOption = (value, language) => {
    switch (language) {
        case 'pt':
            for (let i = 0; i < EU_NON_EU_TRAINING_MODE_LIST.length; i++) {
                if(EU_NON_EU_TRAINING_MODE_LIST[i].code === value) {
                    return { code: value, name: EU_NON_EU_TRAINING_MODE_LIST[i].name };
                }
            }
        break;
        case 'en':
            for (let j = 0; j < EN_EU_NON_EU_TRAINING_MODE_LIST.length; j++) {
                if(EN_EU_NON_EU_TRAINING_MODE_LIST[j].code === value) {
                    return { code: value, name: EN_EU_NON_EU_TRAINING_MODE_LIST[j].name };
                }
            }
        break;
        case 'es':
            for (let j = 0; j < ES_EU_NON_EU_TRAINING_MODE_LIST.length; j++) {
                if(ES_EU_NON_EU_TRAINING_MODE_LIST[j].code === value) {
                    return { code: value, name: ES_EU_NON_EU_TRAINING_MODE_LIST[j].name };
                }
            }
        break;
        case 'fr':
            for (let j = 0; j < FR_EU_NON_EU_TRAINING_MODE_LIST.length; j++) {
                if(FR_EU_NON_EU_TRAINING_MODE_LIST[j].code === value) {
                    return { code: value, name: FR_EU_NON_EU_TRAINING_MODE_LIST[j].name };
                }
            }
        break;
        default:
            break;
    }
}

export const EU_NON_EU_TRAINING_MODE_LIST = [
    { code: "Imediatamente após a conclusão do curso", name: "Imediatamente após a conclusão do curso" },
    { code: "Após um período adicional de prática tutelada", name: "Após um período adicional de prática tutelada" }
];

export const EN_EU_NON_EU_TRAINING_MODE_LIST = [
    { code: "Imediatamente após a conclusão do curso", name: "Immediately upon completion of the course" },
    { code: "Após um período adicional de prática tutelada", name: "After an additional period of tutored practice" }
];

export const ES_EU_NON_EU_TRAINING_MODE_LIST = [
    { code: "Imediatamente após a conclusão do curso", name: "Inmediatamente después de la finalización del curso" },
    { code: "Após um período adicional de prática tutelada", name: "Tras un periodo adicional de prácticas supervisadas" }
];

export const FR_EU_NON_EU_TRAINING_MODE_LIST = [
    { code: "Imediatamente após a conclusão do curso", name: "Immédiatement après la conclusion du cours" },
    { code: "Após um período adicional de prática tutelada", name: "Après une période supplémentaire de pratique supervisée" }
];

// **************************
// PORTUGUESE LEVEL
// **************************

export const PORTUGUESE_LEVEL_LIST = [
    { code: "C2", name: "C2" },
    { code: "C1", name: "C1" },
    { code: "B2", name: "B2" },
    { code: "B1", name: "B1" }
];